module.exports = __webpack_public_path__ + "img/3-longing-nl_v8e_loading.462b041f.jpg";